import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { Location } from '@angular/common';
@Component({
  selector: 'app-dependence-list',
  templateUrl: './dependence-list.component.html',
  styleUrls: ['./dependence-list.component.scss']
})
export class DependenceListComponent implements OnInit {

  response: any;
  dependantsList: any;
  accountDetails: any;
  uuid: any;
  currentUser:any;
  constructor(private router: Router,
    private api: ApiService,
    private route: ActivatedRoute,
    private ngxUiLoaderService: NgxUiLoaderService,

    private location: Location,
    ) {

    if (this.route.snapshot.paramMap.get('id')) {
      this.uuid = this.route.snapshot.paramMap.get('id');
      this.getDependantsList(this.uuid);
    }

  }

  ngOnInit() {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log("30", this.accountDetails.uuid)
      this.currentUser = this.accountDetails.current_user
      this.getDependantsList(this.accountDetails.uuid);
    }

  }
  goBack() {
    this.location.back();
  }

  getUrl(id) {
    //this.router.navigate(['/dependence'], { state: { data: id }} );
    console.log(id)
    this.router.navigate(["/dependence", id])
  }
  goToCreatSection(id) {
    this.router.navigate(['/dependence'], { state: { data: id } });
  }
  getDependantsList(data) {
    if (data) {
      this.ngxUiLoaderService.start();
      this.api.getDependantsList(data).pipe(first())
        .subscribe(data => {
            this.ngxUiLoaderService.stop();
            this.response = data;
            if (this.response.status == 200) {
              this.dependantsList = this.response.results.employee_nominies;
              console.log(this.dependantsList)
              console.log(this.dependantsList && this.dependantsList.length == 0)
            }
          },
          error => {
            this.ngxUiLoaderService.stop();
          });
    }
  }

  goTofamilyAllowanceList(){
    console.log("0000")
    this.router.navigate(["/family-allowance-list", this.uuid])
  }
}
